import React, { useState } from "react";
import PropTypes from "prop-types";
import GuestForm from "./GuestForm";
import ContactForm from "./ContactForm";
import IdentityForm from "./IdentityForm";
import FormCard from "../../../../../../Lib/FormCard";

const CustomerDetails = ({
  formData,
  updateFormData,
  errors,
  disabled,
  index = 0,
  onRemove,
  showRemoveButton = false,
  refs,
  flag = "",
}) => {
  const title = index > 0 ? `User Details ${index}` : "User Details";

  const [filePreview, setFilePreview] = useState(null);
  const [fileType, setFileType] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const fileURL = URL.createObjectURL(file);
    setFilePreview(fileURL);

    const type = file.type;
    if (type.startsWith("image/")) {
      setFileType("image");
    } else if (type === "application/pdf") {
      setFileType("pdf");
    } else {
      setFileType("");
    }
  };

  return (
    <FormCard
      title={title}
      rightAction={
        showRemoveButton && (
          <button
            type="button"
            className="btn btn-sm btn-outline-danger"
            onClick={onRemove}
          >
            <i className="bi bi-x-circle"></i>
          </button>
        )
      }
    >
      <div className="card-body">
        <div className="row g-3">
          <div className="col-md-6 d-flex">
            <GuestForm
              formData={formData}
              onChange={updateFormData}
              errors={errors}
              disabled={disabled}
              index={index}
              refs={refs}
            />
          </div>
          <div className="col-md-6 d-flex">
            <ContactForm
              formData={formData}
              onChange={updateFormData}
              errors={errors}
              disabled={disabled}
              index={index}
              refs={refs}
            />
          </div>
          <div className="col-md-6 d-flex">
            <IdentityForm
              formData={formData}
              onChange={updateFormData}
              errors={errors}
              disabled={disabled}
              index={index}
            />
          </div>

          {/* File Upload and Preview */}
          {/* <div className="col-md-6">
            <label className="form-label">Upload Image or PDF</label>
            <input
              type="file"
              className="form-control"
              accept="image/*,application/pdf"
              onChange={handleFileChange}
              disabled={disabled}
            />
            {filePreview && (
              <div className="mt-3">
                {fileType === 'image' ? (
                  <img src={filePreview} alt="Preview" className="img-fluid rounded border"  width="500px" height="500"/>
                ) : fileType === 'pdf' ? (
                  <embed src={filePreview} type="application/pdf" width="100%" height="400px" />
                ) : (
                  <p className="text-danger">Unsupported file type.</p>
                )}
              </div>
            )}
          </div> */}
        </div>
      </div>
    </FormCard>
  );
};

CustomerDetails.propTypes = {
  formData: PropTypes.object.isRequired,
  updateFormData: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  index: PropTypes.number,
  onRemove: PropTypes.func,
  showRemoveButton: PropTypes.bool,
};

export default CustomerDetails;
